export default __webpack_public_path__ + "static/media/delete.b7e9c7c5.svg";